import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import ExamForm from './ExamForm';
import {
  fetchExam,
  saveExam,
  fetchFormDatas,
} from '../../../redux/actions/examActions';
import {
  deleteInscripcionExamen,
  actualizarNotasProfesor,
} from '../../../redux/actions/inscripcionExamenActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import Confirm from '../../../shared/components/Confirm';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import { dateTimeString } from '../../../helpers/dateFormat';

class ExamFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      exam: {},
      inscriptos: [],
      instanciasExamen: [],
      loading: true,
    };

    this.handleOnFilterChange = this.handleOnFilterChange.bind(this);
    this.handleOnSubjectChange = this.handleOnSubjectChange.bind(this);
    this.handleDeleteInscription = this.handleDeleteInscription.bind(this);
  }

  componentDidMount() {
    this.fetchCurrentExam();
  }

  fetchCurrentExam = () => {
    const { id, history } = this.props;

    if (!id) {
      this.setState({
        exam: {
          id: 0,
          fecha: new Date().toISOString(),
          fechaLimiteInscripcion: new Date().toISOString(),
          fechaInicioReclamo: null,
          fechaFinReclamo: null,
          fechaAtencionReclamos: null,
          estado: { value: 0 },
        },
        inscriptos: [],
      });

      this.fetchDatasList();

      return;
    }

    this.setState({
      loading: true,
    });

    fetchExam(id, {
      onSuccess: (dto) => {
        const { materia } = dto;
        const { interventor, interventorAuxiliar } = dto;
        const exam = {
          ...dto,
          interventor: {
            value: dto.interventorId,
            label: `${interventor}`,
          },
          profesor: {
            value: dto.profesorId,
            label: `${dto.profesor}`,
          },
          interventorAuxiliar: {
            value: dto.interventorAuxiliarId,
            label: `${interventorAuxiliar}`,
          },
          materia: {
            value: dto.materiaPeriodoId,
            label: `${materia}`,
          },
          carrera: {
            value: dto.carreraId,
            label: dto.carrera,
          },
          periodo: {
            value: dto.periodo,
            label: dto.periodo,
          },
          periodoLectivo: {
            value: dto.periodoLectivoId,
            label: dto.periodoLectivo,
          },
        };

        const { inscriptos } = dto;
        if (exam.inscriptos) {
          delete exam.inscriptos;
        }

        this.setState({
          exam,
          inscriptos,
          loading: false,
        });

        this.fetchDatasList(dto.periodoLectivoId);
      },
      onError: (error) => {
        this.setState({
          loading: false,
        });

        if (error && error.status === 404) {
          createErrorMessage('El examen no existe');
          history.push('/pages/exams');
        } else {
          createErrorMessage('Error al intentar cargar los datos del examen');
        }
      },
    });
  }

  fetchDatasList = (anhoLectivoId = 0) => {
    this.setState({
      loading: true,
    });

    fetchFormDatas(anhoLectivoId, {
      onSuccess: ({
        carreras,
        materias,
        profesores,
        periodosLectivos,
        periodosExamen,
        instanciasExamen,
      }) => this.setState({
        carreras,
        materias,
        profesores,
        periodosLectivos,
        periodosExamen,
        instanciasExamen,
        loading: false,
      }),
      onError: () => {
        this.setState({
          loading: false,
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleSubmit = (values) => {
    const {
      id,
      materia,
      interventor,
      profesor,
      interventorAuxiliar,
      fecha,
      fechaLimiteInscripcion,
      fechaAtencionReclamos,
      fechaInicioReclamo,
      fechaFinReclamo,
      notasObservaciones,
      aula,
      nroActa,
    } = values;

    const {
      exam,
    } = this.state;

    const claimStartDate = typeof fechaInicioReclamo === 'undefined'
      ? exam.fechaInicioReclamo
      : fechaInicioReclamo;

    const claimEndDate = typeof fechaFinReclamo === 'undefined'
      ? exam.fechaFinReclamo
      : fechaFinReclamo;

    const attendanceDate = typeof fechaAtencionReclamos === 'undefined'
      ? exam.fechaAtencionReclamos
      : fechaAtencionReclamos;

    const { value: materiaPeriodoId } = materia;
    const { value: interventorId } = interventor;
    const { value: profesorId } = profesor;
    const { periodo: { label: periodo } } = values;
    const { value: interventorAuxiliarId } = (interventorAuxiliar || {});

    const params = {
      id,
      fecha: dateTimeString(fecha),
      fechaLimiteInscripcion: dateTimeString(fechaLimiteInscripcion),
      fechaInicioReclamo: claimStartDate ? dateTimeString(claimStartDate) : null,
      fechaFinReclamo: claimEndDate ? dateTimeString(claimEndDate) : null,
      fechaAtencionReclamos: attendanceDate ? dateTimeString(attendanceDate) : null,
      materiaPeriodoId,
      interventorId,
      profesorId,
      interventorAuxiliarId,
      periodo,
      notasObservaciones,
      aula,
      nroActa,
    };

    const { history } = this.props;

    this.setState({
      loading: true,
    });

    saveExam(params, {
      onSuccess: () => {
        createSuccessMessage('Examen guardado exitosamente');
        history.push('/pages/exams');
      },
      onError: (error = {}) => {
        this.setState({
          loading: false,
        });
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar el examen');
        }
      },
    });
  }

  handleDeleteInscription = (inscription) => {
    const name = `${inscription.nombre} ${inscription.apellido}`;
    Confirm({
      title: 'Borrar inscripción de examen',
      question: `Estás seguro que deseas eliminar la inscripción de ${name}?`,
      yesLabel: 'Si, Borrar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        this.setState({
          loading: true,
        });
        deleteInscripcionExamen(inscription.id, {
          onSuccess: () => {
            this.setState({
              loading: false,
            });
            createSuccessMessage('Examen borrado exitosamente');
            this.fetchCurrentExam();
          },
          onError: (error) => {
            this.setState({
              loading: false,
            });
            if (error && error.status === 404) {
              createErrorMessage('La inscripción de examen no existe');
            } else {
              createErrorMessage('Error al intentar borrar la inscripción examen');
            }
          },
        });
      },
    });
  };

  handleActualizarNotasProfesor = ({
    inscripcionId, porcentajeAsistencia, porcentajePC, porcentajePF, porcentajePP, calificacion,
  }) => {
    actualizarNotasProfesor({
      inscripcionId, porcentajeAsistencia, porcentajePC, porcentajePF, porcentajePP, calificacion,
    }, {
      onSuccess: (inscription) => {
        const { inscriptos } = this.state;

        const newInscriptos = [...inscriptos];
        const elementsIndex = newInscriptos.findIndex(s => s.id === inscription.id);

        newInscriptos[elementsIndex] = inscription;

        this.setState({
          inscriptos: newInscriptos,
        });

        createSuccessMessage('Asistencia y/o notas guardada(s) exitosamente.');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la asistencia y/o nota.');
        }
      },
    });
  };

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    const { exam } = this.state;
    if (idKey === 'carreraId') {
      this.setState({
        exam: {
          ...exam,
          [idKey]: value.value,
          [objectKey]: value,

          materiaPeriodoId: 0,
          materia: { value: 0, label: '-' },

          periodoLectivoId: 0,
          periodoLectivo: { value: 0, label: '-' },

          interventorId: 0,
          interventor: { value: 0, label: '-' },

          profesorId: 0,
          profesor: { value: 0, label: '-' },
        },
      });
      return;
    }

    if (idKey === 'periodoLectivoId') {
      if (value.value > 0) {
        this.setState({
          exam: {
            ...exam,
            [idKey]: value.value,
            [objectKey]: value,

            materiaPeriodoId: 0,
            materia: { value: 0, label: '-' },

            interventorId: 0,
            interventor: { value: 0, label: '-' },

            profesorId: 0,
            profesor: { value: 0, label: '-' },
          },
        });

        this.fetchDatasList(value.value);
        return;
      }

      this.setState({
        exam: {
          ...exam,
          materiaPeriodoId: 0,
          materia: { value: 0, label: '-' },

          periodoLectivoId: 0,
          periodoLectivo: { value: 0, label: '-' },

          interventorId: 0,
          interventor: { value: 0, label: '-' },

          profesorId: 0,
          profesor: { value: 0, label: '-' },
        },
      });

      return;
    }

    this.setState({
      exam: {
        ...exam,
        [idKey]: value.value,
        [objectKey]: value,
      },
    });
  }

  filtrarMaterias = (carreraId) => {
    const { materias } = this.state;
    if (!materias || !carreraId) {
      return [];
    }

    return materias.filter(m => m.parentId === carreraId);
  }

  handleOnSubjectChange = (objectKey, idKey, value) => {
    const { exam } = this.state;
    const profesorName = value.nombre ? `${value.nombre} ${value.apellido}` : '';
    let { interventorId, interventor } = exam;

    if (!interventorId) {
      interventorId = value.usuarioId;
      interventor = { value: interventorId, label: profesorName };
    } else {
      interventorId = 0;
      interventor = { value: interventorId, label: profesorName };
    }

    this.setState({
      exam: {
        ...exam,
        [idKey]: value.value,
        [objectKey]: value,
        profesor: { value: value.usuarioId, label: profesorName },
        interventor,
        interventorId,
      },
    });
  }

  handleChangeText = ({
    target,
  }) => {
    const value = target.type === 'number'
      ? Number(target.value)
      : `${target.value}`.trim();

    this.setState(prev => ({
      exam: {
        ...prev.exam,
        ...{
          [target.name]: value,
        },
      },
    }));
  };

  render() {
    const { id, history } = this.props;
    const {
      exam,
      profesores,
      carreras = [],
      periodosLectivos,
      periodosExamen,
      instanciasExamen = [],
      inscriptos,
      loading,
    } = this.state;

    if (!exam || carreras.length === 0 || loading) {
      return <LoadingSpinner />;
    }

    const materias = this.filtrarMaterias(exam.carreraId);
    const { estado } = exam;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id && [0, 4].includes(estado.value) && 'Editar'}
              {!id && 'Nuevo'}{id && ![0, 4].includes(estado.value) && 'Ver'} examen
            </h3>
            <h3 className="page-subhead subhead">
              {id ? '' : ''}
              {id && [0, 4].includes(estado.value) && 'Modificar '}
              {!id && 'Ingresa '}{id && ![0, 4].includes(estado.value) && 'Ver '}
              la informaci&oacute;n del examen
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(profesores)
              ? (<LoadingSpinner />)
              : (
                <ExamForm
                  {...exam}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={exam}
                  inscriptos={inscriptos}
                  history={history}
                  profesores={profesores}
                  materias={materias}
                  carreras={carreras}
                  periodosLectivos={periodosLectivos}
                  periodosExamen={periodosExamen}
                  instanciasExamen={instanciasExamen}
                  onFilterChanges={this.handleOnFilterChange}
                  onSubjectChanges={this.handleOnSubjectChange}
                  handleDeleteInscription={this.handleDeleteInscription}
                  handleActualizarNotasProfesor={this.handleActualizarNotasProfesor}
                  handleChangeText={this.handleChangeText}
                  enableReinitialize
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

ExamFormContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default ExamFormContainer;
